import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

const initState = {
  resourceName: null,
  type: null,
  status:null,
};

export const ViewResourcesData = {
  name: "RecordListForm",
  initialState: initState,
  section: [
    {
      title: "RecordListForm",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "RecordListForm",
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="form-card row"></div>,
          fields: [
            {
              id: "resourceName",
              label: "Search by Name",
              Field_Name: "SearchByName",
              fieldType: FormFieldTypes.INPUT,
              dataField: "resourceName",
              fieldSetting: {
                allowSpace: false,
              },
              style: {
                containerCss: "col-lg-4 col-md-6",
              },
            },
            {
              id: "type",
              label: "Type",
              Field_Name: "Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "type",
              fieldSetting: {
                placeholder: "Select",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
              },
            },
            {
              id: "status",
              label: "Status",
              Field_Name: "Status",
              fieldType: FormFieldTypes.SELECT,
              dataField: "status",
              fieldSetting: {
                placeholder: "Select",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
              },
            },
          ],
        },
      ],

    },
  ],
};
